import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PersonaConsultadaDTO } from '../../../../../dto/tramites/sic/persona-consultada-dto';

@Injectable({
  providedIn: 'root',
})
export class ListaValorService {
  private apiUrl = `${environment.apiUrl}`;

  constructor(private http: HttpClient) {}

  lista(endpoint: string) {
    return this.http.get(`${this.apiUrl}/lista/listavalor/${endpoint}`).pipe();
  }

  persona(
    tipo: number,
    identificacion: string
  ): Observable<PersonaConsultadaDTO> {
    return this.http
      .get<PersonaConsultadaDTO>(
        `${this.apiUrl}/persona/obtenerPorTipoYNumDocumento/${tipo}/${identificacion}`
      )
      .pipe();
  }

  getFestivos(): Observable<{ Id: number; Fecha: string }[]> {
    return this.http.get<{ Id: number; Fecha: string }[]>(`${this.apiUrl}/lista/festivos`);
  }
}
